import { render, staticRenderFns } from "./VideoLinks.vue?vue&type=template&id=a1f84bd8&scoped=true&"
import script from "./VideoLinks.vue?vue&type=script&lang=js&"
export * from "./VideoLinks.vue?vue&type=script&lang=js&"
import style0 from "./VideoLinks.vue?vue&type=style&index=0&id=a1f84bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f84bd8",
  null
  
)

export default component.exports